<template>
  <div v-loading="rebuttalLoading" element-loading-spinner="atom-audit-loader">
    <transition-group name="fade">
      <div v-if="rebuttal" style="margin: 0px 0px 0px 0px; min-height: 250px;" key="1">
        <div style="margin-left: 10px;">
          <el-form ref="form" id="form" label-position="left" label-width="200px" size="mini" :key="1" style="margin-top: 0px;">
            <el-form-item label="Response Date">
              <div style="margin: 6px 0 0 15px;">{{ formatDate(rebuttal.rebuttalDate) }}</div>
            </el-form-item>
            <el-form-item v-if="worksheet.auditResult !== 'No Change'" :label="worksheet.projectReviewTypeId === 2 ? 'Auditor agrees with changes' : 'Coder agrees with changes'">
              <el-col style="margin-top: 3px;"> <input :disabled="coderResponsesReadOnly()" type="radio" name="codes" :value="true" v-model="rebuttal.agreeWithCodes" @change="putRebuttal" /> Yes <input :disabled="coderResponsesReadOnly()" type="radio" name="codes" :value="false" v-model="rebuttal.agreeWithCodes" @change="putRebuttal" /> No </el-col>
            </el-form-item>
            <el-form-item v-if="worksheet.auditResult !== 'No Change'" :label="worksheet.projectReviewTypeId === 2 ? 'Level 2 Auditor response required' : 'Auditor Response Required'">
              <el-col style="margin-top: 3px;"> <input :disabled="(rebuttal.agreeWithCodes ? false : true) || coderResponsesReadOnly()" type="radio" name="auditor" :value="true" v-model="rebuttal.auditorResponseRequired" @change="putRebuttal" /> Yes <input :disabled="(rebuttal.agreeWithCodes ? false : true) || coderResponsesReadOnly()" type="radio" name="auditor" :value="false" v-model="rebuttal.auditorResponseRequired" @change="putRebuttal" /> No </el-col>
            </el-form-item>
          </el-form>

          <div style="margin-top: 20px; font-size: 13px;" v-for="comment in rebuttal.rebuttalComments.filter(x => x.commentId)" :key="comment.commentId">
            {{ comment.user.fullName }} on <i>{{ format(parseISO(comment.createdDate), 'M/d/yyyy hh:mm a') }}</i> <span style="font-weight: bold;" :title="format(parseISO(comment.modifiedDate), 'M/d/yyyy hh:mm a')" v-if="comment.edited"><small>edited</small></span>

            <HiaRichText @change="putComment(comment)" :editable="user.auth0Id === comment.user.auth0Id && !coderResponsesReadOnly()" v-model="comment.comment" :title="`${comment.user.fullName} on ${format(parseISO(comment.createdDate), 'M/d/yyyy hh:mm a')}`"> </HiaRichText>
          </div>
          <div style="margin-top: 15px;">
            <Tinymce :disabled="coderResponsesReadOnly()" placeholder="Add comment" id="newCommentExistingRebuttal" :height="250" v-model="newComment" @dirty="$emit('dirty', true)"> </Tinymce>
          </div>
        </div>
      </div>
    </transition-group>
    <div style="margin-top: 20px;">
      <el-button :disabled="coderResponsesReadOnly()" v-if="!newMode && !rebuttal" class="hiaButton" plain round @click="addRebuttal(true)" size="mini">Create Response</el-button>

      <el-popover ref="savePopover" style="word-break: normal;margin-left: 10px;" placement="bottom" title="" width="300" trigger="manual" popper-class="popover" :content="savePopoverContent" v-model="showSavePopover" @after-enter="handleHidePopOver('savePopover')">
        <el-button icon="el-icon-check" :disabled="coderResponsesReadOnly()" v-if="worksheet.auditResult === 'No Change' && newMode" slot="reference" class="hiaButton" plain round size="mini" @click="postRebuttal">Acknowledge No Change</el-button>
        <el-button icon="el-icon-plus" :disabled="coderResponsesReadOnly()" v-if="newMode && worksheet.auditResult !== 'No Change'" slot="reference" class="hiaButton" plain round size="mini" @click="postRebuttal">Add Response</el-button>
        <el-button icon="el-icon-plus" :disabled="coderResponsesReadOnly()" v-if="rebuttal && rebuttal.rebuttalId" slot="reference" class="hiaButton" plain round size="mini" @click="addComment">Add Comment </el-button>
      </el-popover>
    </div>
  </div>
</template>

<script>
  import Tinymce from '@/components/controls/Tinymce'
  import HiaRichText from '@/components/controls/HiaRichText'
  import dateHelper from '@/mixins/date-helper'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import coderReviewStatusHelper from '@/mixins/coderReviewStatusHelper'
  import { format, parseISO } from 'date-fns'
  import { mapActions, mapState, mapMutations } from 'vuex'

  export default {
    name: 'coderProResponses',
    mixins: [dateHelper, HiaAuthorization, coderReviewStatusHelper],
    props: ['worksheet', 'proRecordId'],
    data() {
      return {
        format: format,
        parseISO: parseISO,
        disabled: true,
        newComment: '',
        loading: false,
        newMode: false,
        rebuttalLoading: false,
        showSavePopover: false,
        savePopoverContent: null
      }
    },
    components: {
      Tinymce,
      HiaRichText
    },
    methods: {
      ...mapActions('rebuttals/', ['POST_REBUTTAL', 'DELETE_REBUTTAL', 'PUT_REBUTTAL', 'POST_REBUTTAL_COMMENT', 'PUT_REBUTTAL_COMMENT']),
      ...mapMutations('rebuttals/', ['SET_REBUTTAL']),
      async putComment(comment) {
        try {
          this.rebuttalLoading = true
          await this.PUT_REBUTTAL_COMMENT(comment)
          this.rebuttalLoading = false
        } catch (e) {
          this.rebuttalLoading = false
          this.$message({
            message: 'Error Editing Comment',
            type: 'error'
          })
          console.log(e)
        }
      },
      async addComment() {
        if (!this.newComment) {
          this.savePopoverContent = 'Comment field is empty'
          this.showSavePopover = true
          return
        }

        try {
          this.rebuttalLoading = true
          await this.POST_REBUTTAL_COMMENT({
            rebuttalId: this.rebuttal.rebuttalId,
            comment: this.newComment
          })
          this.newComment = ''
          this.rebuttalLoading = false
          this.$emit('dirty', false)
        } catch (e) {
          this.$message({
            message: 'Error Adding Comment',
            type: 'error'
          })
          console.log(e)
          this.rebuttalLoading = false
        }
      },
      async postRebuttal() {
        if (this.rebuttal.agreeWithCodes === null && this.worksheet.auditResult !== 'No Change') {
          this.savePopoverContent = "Please select above whether you agree or disagree with the auditor's changes"
          this.showSavePopover = true
          return
        }

        if (this.rebuttal.agreeWithCodes === false && !this.newComment) {
          this.savePopoverContent = 'When disagreeing with auditor, please use a comment to document your rationale for disagreement'
          this.showSavePopover = true
          return
        }

        // if (this.rebuttal.agreeWithCodes === null) {
        //   this.showSavePopover = true
        //   return
        // }

        try {
          if (!this.rebuttal.agreeWithCodes) {
            this.rebuttal.auditorResponseRequired = true
          } else if (this.rebuttal.auditorResponseRequired == null) {
            this.rebuttal.auditorResponseRequired = false
          }
          const rebuttalComments = this.newComment ? [{ comment: this.newComment, rebuttalId: 0 }] : []
          this.rebuttal.rebuttalComments = rebuttalComments
          this.rebuttalLoading = true
          await this.POST_REBUTTAL(this.rebuttal)
          await this.$emit('GET_PRO_WORKSHEET', this.$route.params.proRecordId)
          this.$message({
            message: 'Coder Response Added Successfully',
            type: 'success'
          })
          this.newMode = false
          this.newComment = ''
          this.rebuttalLoading = false
          this.$emit('dirty', false)
        } catch (err) {
          this.$message({
            message: 'Error Adding Coder Response',
            type: 'error'
          })
        }
      },
      async putRebuttal() {
        if (!this.rebuttal.agreeWithCodes) {
          this.rebuttal.auditorResponseRequired = true
        }

        if (!this.rebuttal.rebuttalId) {
          this.$emit('dirty', true)
          return
        }

        try {
          await this.PUT_REBUTTAL(this.rebuttal)

          this.$message({
            message: 'Coder Response Updated Successfully',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            message: 'Error Updating Coder Response',
            type: 'error'
          })
        }
      },
      addRebuttal(agree) {
        this.SET_REBUTTAL({
          agreeWithCodes: null,
          auditorResponseRequired: null,
          rebuttalDate: new Date().toISOString(),
          proRecordId: this.proRecordId,
          rebuttalComments: []
        })

        this.newMode = true
      },
      handleHidePopOver(ref) {
        const popper = this.$refs[ref]
        const handler = e => {
          if (e.target !== popper.$el) {
            popper.doDestroy()
            popper.doClose()
          }
          document.removeEventListener('click', handler, false)
        }
        document.addEventListener('click', handler, false)
      },
      appendDxResponseComment(val) {
        if (val.preDxDeleted && val.preDx) {
          this.newComment += `<p><b>Dx ${val.preDx} deleted</b></p>`
          return
        }

        if (val.originalDeleted && (val.originalDx || val.preDx)) {
          this.newComment += `<p><b>Dx ${val.originalDx || val.preDx} deleted</b></p>`
          return
        }

        if (val.originalDx && val.recommendedDx && !val.originalDeleted) {
          const fromCode = val.originalDx || val.preDx
          if (fromCode !== val.recommendedDx) {
            this.newComment += `<p><b>Dx ${fromCode} changed to ${val.recommendedDx}</b></p>`
          }
          return
        }

        if (val.preDx && val.recommendedDx && val.recommendedDx !== val.preDx && !val.originalDeleted) {
          this.newComment += `<p><b>Dx ${val.preDx} changed to ${val.recommendedDx}</b></p>`
          return
        }

        if (val.preDx && val.originalDx && val.originalDx !== val.preDx && !val.recommendedDx && !val.originalDeleted) {
          this.newComment += `<p><b>Dx ${val.preDx} changed to ${val.originalDx}</b></p>`
          return
        }

        if (!val.originalDx && !val.preDx && val.recommendedDx) {
          this.newComment += `<p><b>Dx ${val.recommendedDx} added</b></p>`
          return
        }

        if (val.recommendedPOA) {
          this.newComment += `<p><b>Dx POA ${val.recommendedPOA} recommended on ${val.recommendedDx || val.originalDx || val.preDx}</b></p>`
        }
      },
      appendCptResponseComment(val) {
        if (val.preCptDeleted && val.preCpt) {
          this.newComment += `<p><b>CPT ${val.preCpt} deleted</b></p>`
          return
        }

        if (val.originalDeleted && (val.originalCPT || val.preCpt)) {
          this.newComment += `<p><b>CPT ${val.originalCPT || val.preCpt} deleted</b></p>`
          return
        }

        if (val.originalCPT && val.recommendedCpt && !val.originalDeleted) {
          const fromCode = val.originalCPT || val.preCpt
          if (fromCode !== val.recommendedCpt) {
            this.newComment += `<p><b>CPT ${fromCode} changed to ${val.recommendedCpt}</b></p>`
          }
          return
        }

        if (val.preCpt && val.recommendedCpt && val.recommendedCpt !== val.preCpt && !val.originalDeleted) {
          this.newComment += `<p><b>CPT ${val.preCpt} changed to ${val.recommendedCpt}</b></p>`
          return
        }

        if (val.preCpt && val.originalCPT && val.originalCPT !== val.preCpt && !val.recommendedCpt && !val.originalDeleted) {
          this.newComment += `<p><b>CPT ${val.preCpt} changed to ${val.originalCPT}</b></p>`
          return
        }

        if (!val.originalCPT && !val.preCpt && val.recommendedCpt) {
          this.newComment += `<p><b>CPT ${val.recommendedCpt} added</b></p>`
          return
        }

        if (val.recommendedModifiers && val.recommendedModifiers !== val.originalModifiers) {
          const code = val.recommendedCpt || val.originalCPT || val.preCpt
          if (code) {
            this.newComment += `<p><b>CPT ${code} modifier change recommended</b></p>`
          }
        }
      }
    },
    created: function() {
      if (!this.rebuttal.rebuttalId && !this.coderResponsesDisabled()) {
        this.addRebuttal(true)
      }
    },
    computed: {
      ...mapState('rebuttals/', ['rebuttal']),
      ...mapState('user/', ['user']),
      ...mapState('coder/', ['responseRow', 'responseDRG', 'responsePatStat', 'responsePOO'])
    },
    watch: {
      responseDRG(val) {
        if (val.originalDrg && val.recommendedDrg) {
          this.newComment += `<p><b>Original DRG ${val.originalDrg} changed to ${val.recommendedDrg}</b></p>`
        } else {
          this.newComment += `<p><b>DRG changed to ${val.recommendedDrg}</b></p>`
        }
      },
      responsePatStat(val) {
        if (val.originalPatStat && val.recommendedPatStat) {
          this.newComment += `<p><b>Original Patient Status ${val.originalPatStat} changed to ${val.recommendedPatStat}</b></p>`
        } else {
          this.newComment += `<p><b>Patient Status changed to ${val.recommendedPatStat}</b></p>`
        }
      },
      responsePOO(val) {
        if (val.originalPoo && val.recommendedPoo) {
          this.newComment += `<p><b>Original Point of Origin ${val.originalPoo} changed to ${val.recommendedPoo}</b></p>`
        } else {
          this.newComment += `<p><b>Point of Origin changed to ${val.recommendedPoo}</b></p>`
        }
      },
      responseRow(val) {
        if (!val || val._respondClickedAt == null) {
          return
        }

        if (val.cptId != null || val.originalCPT != null || val.preCpt != null) {
          const commentBefore = this.newComment
          this.appendCptResponseComment(val)
          if (this.newComment !== commentBefore) {
            this.$emit('dirty', true)
          }
          return
        }

        if (val.dxId != null || val.preDx != null || val.originalDx != null) {
          if (val.reasonForChange === 'Resequence PDx') {
            this.newComment += `<p><b>Principal Dx resequenced to ${val.recommendedDx}</b></p>`
            this.$emit('dirty', true)
            return
          }

          if (val.reasonForChange === 'Resequence SDx') {
            this.newComment += `<p><b>Secondary Dx resequenced to ${val.recommendedDx}</b></p>`
            this.$emit('dirty', true)
            return
          }

          const commentBefore = this.newComment
          this.appendDxResponseComment(val)
          if (this.newComment !== commentBefore) {
            this.$emit('dirty', true)
          }
        }
      }
    }
  }
</script>

<style scoped>
  .richText {
    border: 1px solid #dcdfe6;
    background: #e5eef4;
    border-radius: 4px;
    padding: 5px;
    margin: 10px 0 20px 0px;
    min-height: 30px;
    font-size: 14px;
    overflow-x: auto;
  }

  .richText img {
    width: 100%;
    /* or any custom size */
    height: 100%;
    object-fit: contain;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    height: 0px;
  }
</style>
